import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog(props: any) {
  const { msg, content, alertDialogOpen, setAlertDialogOpen, doAction } = props

  const cancel = () => {
    setAlertDialogOpen(false)
  }

  const doIt = () => {
    doAction()
    setAlertDialogOpen(false)
  }

  return (
    <div>
      <Dialog
        open={alertDialogOpen}
        onClose={cancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{msg}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancel} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button onClick={doIt} variant="outlined" color="secondary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
